import { lazy } from 'react';

const TradeInRoutes = [
  // Brands
  {
    path: 'trade-in/brands',
    component: lazy(() => import('views/trade-in/brands')),
  },
  {
    path: 'trade-in/brands/add',
    component: lazy(() => import('views/trade-in/brands/brand-add')),
  },
  {
    path: 'trade-in/brands/:id',
    component: lazy(() => import('views/trade-in/brands/brand-edit')),
  },
  // Device Models
  {
    path: 'trade-in/device-models',
    component: lazy(() => import('views/trade-in/device-models')),
  },
  {
    path: 'trade-in/device-models/add',
    component: lazy(() => import('views/trade-in/device-models/device-model-add')),
  },
  {
    path: 'trade-in/device-models/:id',
    component: lazy(() => import('views/trade-in/device-models/device-model-edit')),
  },
  // Commercial settings: validity, depreciation, shipping, payout fees.
  {
    path: 'trade-in/settings',
    component: lazy(() => import('views/trade-in/settings')),
  },
  // The kinds of device the shop takes in; each owns a questionnaire.
  {
    path: 'trade-in/device-types',
    component: lazy(() => import('views/trade-in/device-types')),
  },
  // Questionnaire — the wording and deductions the shop tunes.
  {
    path: 'trade-in/questions',
    component: lazy(() => import('views/trade-in/questions')),
  },
  // Variants
  {
    path: 'trade-in/variants',
    component: lazy(() => import('views/trade-in/variants')),
  },
  {
    path: 'trade-in/variants/add',
    component: lazy(() => import('views/trade-in/variants/variant-add')),
  },
  {
    path: 'trade-in/variants/:id',
    component: lazy(() => import('views/trade-in/variants/variant-edit')),
  },
  // Condition Grades
  {
    path: 'trade-in/condition-grades',
    component: lazy(() => import('views/trade-in/condition-grades')),
  },
  {
    path: 'trade-in/condition-grades/add',
    component: lazy(() => import('views/trade-in/condition-grades/condition-grade-add')),
  },
  {
    path: 'trade-in/condition-grades/:id',
    component: lazy(() => import('views/trade-in/condition-grades/condition-grade-edit')),
  },
  // Price Matrix
  {
    path: 'trade-in/prices',
    component: lazy(() => import('views/trade-in/prices')),
  },
  // Requests
  {
    path: 'trade-in/requests',
    component: lazy(() => import('views/trade-in/requests')),
  },
  {
    path: 'trade-in/requests/:id',
    component: lazy(() => import('views/trade-in/requests/request-details')),
  },
];

export default TradeInRoutes;
